import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  isDevMode,
} from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { TenantRouteReuseStrategy } from './tenant-route-reuse.strategy';
import { provideTransloco, TranslocoLoader } from '@jsverse/transloco';
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

const AVAILABLE_LANGS = ['en-GB', 'it-IT'];

function getBrowserLang(): string {
  const lang = navigator.language;
  if (AVAILABLE_LANGS.includes(lang)) return lang;
  const prefix = lang.split('-')[0];
  return AVAILABLE_LANGS.find((l) => l.startsWith(prefix)) ?? 'en-GB';
}

@Injectable({ providedIn: 'root' })
class AppTranslocoLoader implements TranslocoLoader {
  private http = inject(HttpClient);
  getTranslation(lang: string) {
    return this.http.get<Record<string, unknown>>(`/assets/i18n/${lang}.json`);
  }
}
import { appRoutes } from './app.routes';
import Aura from '@openng/optimus-ui-themes/aura';
import { provideApi } from '@vasta/api-vasta';
import { provideAuth } from '@vasta/client-core-authentication';
import { provideClientMenu } from '@vasta/client-core-layout';
import { provideUiConfirm } from '@vasta/frontend-ui-overlay';
import { provideErrorHandling } from '@vasta/frontend-shared-core-error-handling';
import { ENVIRONMENT } from '@vasta/env';
import { environment } from '../environments/environment';
import { definePreset } from '@openng/optimus-ui-themes';
import { provideOptimus } from '@openng/optimus-ui/config';

export const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{purple.50}',
      100: '{purple.100}',
      200: '{purple.200}',
      300: '{purple.300}',
      400: '{purple.400}',
      500: '{purple.500}',
      600: '{purple.600}',
      700: '{purple.700}',
      800: '{purple.800}',
      900: '{purple.900}',
      950: '{purple.950}',
    },
    focusRing: {
      color: '{purple.500}',
      offset: '2px',
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes),
    { provide: RouteReuseStrategy, useClass: TenantRouteReuseStrategy },
    provideAuth({ publicPathPrefixes: ['/p'] }),
    provideClientMenu(),
    provideUiConfirm(),
    provideOptimus({
      theme: {
        preset: MyPreset,
        options: {
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng',
          },
          darkModeSelector: '.dark',
        },
      },
    }),
    { provide: ENVIRONMENT, useValue: environment },
    provideApi(environment.apiBaseUrl),
    provideErrorHandling(),
    provideTransloco({
      config: {
        availableLangs: ['en-GB', 'it-IT'],
        defaultLang: getBrowserLang(),
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: AppTranslocoLoader,
    }),
  ],
};
